import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import HtmlEditor from "../../../components/UI/HtmlEditorInput/HtmlEditor";
import SelectInputCachedFormik from "../../../components/UI/SelectInput/SelectInputCachedFormik";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TableContribuinteParteServico from "./TableContribuinteParteServico";
import SelectFileInput from "../../../components/UI/SelectFileInput/SelectFileInput";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import HtmlToString from "../../../components/Formatters/HtmlToString";
import SelectInputParteServicoFormik from "../../../components/UI/SelectInput/SelectInputParteServicoFormik";
import SelectInputTipoParteServicoFormik from "../../../components/UI/SelectInput/SelectInputTipoParteServicoFormik";
import CheckBoxFormik from "../../../components/UI/Checkbox/CheckBoxFormik";
import useSetGuard from "../../../hooks/useSetGuard";
import { signalrActions } from "../../../redux/signalr";

const validationSchema = Yup.object().shape({
  sqParteServico: Yup.string().default(),
  sqTipoParteServico: Yup.string().default("").required("Escolha um Tipo de Parte de Serviço"),
  sqTipoInaptidao: Yup.string().default(),
  sqOrgaoDestino: Yup.string().default("").required("Escolha um setor de destino"),
  txTextoPadrao: Yup.string().ensure().default("").required("Informe o Texto de Parte de Serviço"),
  anexos: Yup.array().max(3, "No máximo 3 anexos podem ser submetidos. "),
  contribuinte: Yup.array()
    .default([])
    .test("qtd-contribuinte", "Selecione pelo menos 1 contribuinte", (value) => (value || []).length > 0),
  isAssinar: Yup.boolean(),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "contribuinte" || key === "anexos") {
    initialValues[key] = [];
  } else if (key === "isAssinar") {
    initialValues[key] = true;
  } else {
    initialValues[key] = "";
  }
});

const ParteServicoOs = ({ dadosOs, history, location }) => {
  const { state } = location;
  const [dataListaContribuinte, setdataListaContribuinte] = useState([]);
  const [erroContribuinte, setErroContribuinte] = useState("");
  const [selectInaptidao, setSelectInaptidao] = useState("");
  const [selectOrgaoDestino, setSelectOrgaoDestino] = useState("");
  const [selectParteServico, setSelectParteServico] = useState("");
  const [siglaOrgao, setSiglaOrgao] = useState("");
  const [isListaContribuinte, setIsListaContribuinte] = useState(false);
  const [parteServico, setParteServico] = useState("");
  const [showTextoParteServico, setShowTextoParteServico] = useState(true);
  const [showModalParteServico, setShowModalParteServico] = useState({
    show: false,
    body: null,
    context: null,
  });

  const setGuardClient = useSetGuard();
  const { push } = history;

  const { filaAssinaturaSucessoStateKey, filaAssinaturaFalhaStateKey } =
    useSelector((stateSignalr) => stateSignalr.signalr) || {};

  const dispatch = useDispatch();

  const { request: requestSafePayload, data: dataSafePayload } = useApiClient();

  const { request: salvarRequest, data: salvarData, errors: salvarErrors, isLoading: salvarIsLoading } = useApiClient();

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const parametros = {
        sqParteServico: values.sqParteServico,
        contribuinte: [
          {
            sequencialPessoa: dadosOs.sqPessoa,
            sequencialContribuinte: dadosOs.sqContribuinte,
          },
        ],
        sqTipoParteServico: values.sqTipoParteServico,
        sqTipoInaptidao: values.sqTipoInaptidao,
        sqOrgaoDestino: values.sqOrgaoDestino,
        txTextoPadrao: values.txTextoPadrao,
        anexos: values.anexos,
        isAssinar: values.isAssinar,
      };

      if (values.sqParteServico) {
        salvarRequest(apiRoutes.fiscalizacao.parteservico.alterarParteServico, parametros);
      } else salvarRequest(apiRoutes.fiscalizacao.parteservico.inserirParteServico, parametros);
    },
  });

  const { setValues, setSubmitting } = formik;

  useEffect(() => {
    if (salvarIsLoading) return;

    if (!salvarData && !salvarErrors) return;

    if (salvarData) {
      toast.success(salvarData.result);
      requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, salvarData.result);
      push("/app/parteservico");
    }

    setSubmitting(false);
  }, [salvarData, salvarErrors, salvarIsLoading, setSubmitting, requestSafePayload, push]);

  const {
    request: parteServicoRequest,
    data: parteServicoData,
    errors: parteServicoErrors,
    isLoading: parteServicoLoading,
  } = useApiClient();

  useEffect(() => {
    if (state && state.itemKey) {
      parteServicoRequest(apiRoutes.fiscalizacao.parteservico.listaParteServico, { id: state.itemKey });
      delete state.itemKey;
    }
  }, [parteServicoRequest, state]);

  useEffect(() => {
    if ((!parteServicoData && !parteServicoErrors) || parteServicoLoading) return;

    if (parteServicoData.result.length > 0) {
      setSelectOrgaoDestino("OrgaoDestino");
    } else {
      setSelectOrgaoDestino("");
    }

    if (parteServicoErrors) {
      toast.error(parteServicoErrors.message);
    }
  }, [formik, parteServicoData, parteServicoErrors, parteServicoLoading]);

  const {
    request: requestContribuinte,
    data: dataContribuinte,
    errors: errorContribuinte,
    isLoading: loadContribuinte,
  } = useApiClient();

  useEffect(() => {
    const params = { listaContribuinte: dadosOs.inscricaoEstadual };
    requestContribuinte(apiRoutes.fiscalizacao.procedimentoFiscal.consultaContribuinte, params);
  }, [requestContribuinte, dadosOs.inscricaoEstadual]);

  const {
    request: requestTextoParteServico,
    data: dataTextoParteServico,
    isLoading: loadTextoParteServico,
  } = useApiClient();

  useEffect(() => {
    if (formik.values.sqTipoParteServico) {
      const params = {
        id: formik.values.sqTipoParteServico,
        sqTipoInaptidao: formik.values.sqTipoInaptidao === "" ? 0 : formik.values.sqTipoInaptidao,
        pageSize: 10,
        pageNumber: 1,
      };
      requestTextoParteServico(apiRoutes.fiscalizacao.parteservico.getTextoParteServico, params);
    }
  }, [requestTextoParteServico, formik.values.sqTipoParteServico, formik.values.sqTipoInaptidao]);

  const trocarTextoFormik = useCallback(
    (texto) => {
      setValues((obj) => ({ ...obj, txTextoPadrao: texto }));
    },
    [setValues],
  );

  useEffect(() => {
    if (dataTextoParteServico && !loadTextoParteServico) {
      trocarTextoFormik(dataTextoParteServico?.result[0]?.txTextoPadrao);
    }
  }, [dataTextoParteServico, loadTextoParteServico, trocarTextoFormik]);

  useEffect(() => {
    if (dataContribuinte && !loadContribuinte) {
      if (dataContribuinte.result.encontrados.length > 0) {
        setSelectParteServico("ParteServico");
        setSelectOrgaoDestino("OrgaoDestino");
        setIsListaContribuinte(true);
        setSiglaOrgao(dataContribuinte.result.encontrados[0]?.siglaOrgao);

        dataContribuinte.result.encontrados.forEach((item) => {
          if (
            !dataListaContribuinte.find(
              (x) =>
                x.sequencialPessoa === item.sequencialPessoa &&
                x.sequencialContribuinte === item.sequencialContribuinte,
            )
          ) {
            setdataListaContribuinte(dataContribuinte.result.encontrados);
          }
        });
      } else {
        setSelectParteServico("");
        setSelectOrgaoDestino("");
        setIsListaContribuinte(true);
        setSiglaOrgao("");
      }

      if (dataContribuinte.result.naoEncontrados.length > 0) {
        setErroContribuinte(
          `Documentos não encontrados em nossa base de dados: ${dataContribuinte.result.naoEncontrados}`,
        );
      } else setErroContribuinte("");
    }

    if (errorContribuinte && !loadContribuinte) setErroContribuinte("");
  }, [requestContribuinte, dataContribuinte, errorContribuinte, loadContribuinte, dataListaContribuinte]);

  useEffect(() => {
    if (document.getElementById("sqTipoParteServico")) {
      const tpParteServico =
        document.getElementById("sqTipoParteServico").options[
          document.getElementById("sqTipoParteServico").selectedIndex
        ].text;

      if (tpParteServico !== parteServico) {
        setParteServico(tpParteServico);

        if (tpParteServico === "Selecione") {
          if (isListaContribuinte) {
            setValues((obj) => ({ ...obj, sqOrgaoDestino: 0, sqTipoInaptidao: "" }));
          }
        }

        if (tpParteServico === "Inaptidão de IE" || tpParteServico === "Inaptidão de IE") {
          setSelectInaptidao("Inaptidão de IE");
          if (isListaContribuinte) {
            if (siglaOrgao === "6 URT") {
              setValues((obj) => ({ ...obj, sqOrgaoDestino: 9 }));
            } else {
              setValues((obj) => ({ ...obj, sqOrgaoDestino: 12 }));
            }
          }
        } else {
          setSelectInaptidao("");
          setValues((obj) => ({ ...obj, sqTipoInaptidao: "" }));
        }

        if (tpParteServico === "Apreensão de Equipamentos") {
          if (isListaContribuinte) {
            if (siglaOrgao === "6 URT") {
              setValues((obj) => ({ ...obj, sqOrgaoDestino: 9 }));
            } else {
              setValues((obj) => ({ ...obj, sqOrgaoDestino: 12 }));
            }
          }
        }

        if (tpParteServico === "Credenciamento NFE-MEI" || tpParteServico === "Desbloqueio MEI") {
          if (isListaContribuinte) {
            setValues((obj) => ({ ...obj, sqOrgaoDestino: 12 }));
          }
        }

        if (
          tpParteServico !== "Apreensão de Equipamentos" &&
          tpParteServico !== "Credenciamento NFE-MEI" &&
          tpParteServico !== "Desbloqueio MEI" &&
          tpParteServico !== "Inaptidão de IE"
        ) {
          setValues((obj) => ({ ...obj, sqOrgaoDestino: 12 }));
          setSelectOrgaoDestino("OrgaoDestino");
        }
      }
    }
  }, [formik, isListaContribuinte, siglaOrgao, parteServico, dataTextoParteServico, loadTextoParteServico, setValues]);

  const resetForm = () => {
    formik.resetForm();
  };

  // Assinatura de PARTE DE SERVIÇO
  const assinaturaHandler = useCallback(
    (safePayload) => {
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );

  useEffect(() => {
    if (dataSafePayload) {
      assinaturaHandler(dataSafePayload.result);
    }
  }, [dataSafePayload, assinaturaHandler]);

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success("Assinatura concluída com sucesso. ", { toastId: filaAssinaturaSucessoStateKey });
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, filaAssinaturaSucessoStateKey, history]);

  useEffect(() => {
    if (filaAssinaturaFalhaStateKey) {
      toast.error("Assinatura concluída com erros. ", { toastId: filaAssinaturaFalhaStateKey });
    }
    return () => {
      dispatch(signalrActions.clearState(filaAssinaturaFalhaStateKey));
    };
  }, [dispatch, filaAssinaturaFalhaStateKey, history]);

  return (
    <>
      <EfisModal
        show={showModalParteServico.show}
        body={showModalParteServico.body}
        title="Texto da Parte de Serviço"
        size="lg"
        closeHandler={() => setShowModalParteServico({ show: false })}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
      />

      <div className="row">
        <div className="col-lg-12">
          <div className="card mb-4">
            <div className="card-body">
              <FormAlert
                formik={formik}
                data={salvarData}
                errors={salvarErrors}
                isLoading={salvarIsLoading}
                dismissible
              />

              <FormAlert
                formik={formik}
                data={dataContribuinte}
                errors={errorContribuinte}
                isLoading={loadContribuinte}
              />
              <Row hidden={erroContribuinte === ""}>
                <Form.Group as={Col} sm={12} md={12}>
                  <Alert variant="danger" className="text-center">
                    {erroContribuinte}
                  </Alert>
                </Form.Group>
              </Row>

              <Row style={{ marginBottom: 50 }}>
                <Form.Group as={Col} sm={12} md={12}>
                  <TableContribuinteParteServico data={dataListaContribuinte} formik={formik} field="contribuinte" />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col} sm={12} md={6}>
                  <Form.Label className="form-control-alt">Tipo de Parte de Serviço:</Form.Label>
                  <SelectInputTipoParteServicoFormik
                    className="form-control-alt"
                    formik={formik}
                    field="sqTipoParteServico"
                    tipoItem="tipo-parte-servico"
                    style={{ width: "100% !important" }}
                    disabled={
                      selectParteServico === "" ||
                      (selectParteServico === "" && formik.values.txStParteServico !== "S") ||
                      formik.values.txStParteServico === "A"
                    }
                  />
                </Form.Group>
                <Form.Group as={Col} sm={12} md={6}>
                  <Form.Label className="form-control-alt">Tipo de Inaptidão:</Form.Label>
                  <SelectInputCachedFormik
                    className="form-control-alt"
                    formik={formik}
                    field="sqTipoInaptidao"
                    tipoItem="tipo-inaptidao"
                    disabled={selectInaptidao === "" || formik.values.txStParteServico === "A"}
                  />
                  <Form.Control.Feedback type="invalid" hidden={formik.values.sqTipoInaptidao}>
                    {selectInaptidao ? "Escolha um tipo de inaptidão" : ""}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={12} md={12} className="mt-4">
                  <Form.Label className="form-control-alt">Setor Destino:</Form.Label>
                  <SelectInputParteServicoFormik
                    formik={formik}
                    field="sqOrgaoDestino"
                    tipoItem="orgaos-geral"
                    disabled={selectOrgaoDestino === ""}
                  />
                </Form.Group>

                <Form.Group as={Col} xs={12} md={12} className="my-4">
                  <Form.Label className="form-control-alt">
                    Texto da Parte de Serviço
                    <BiEdit
                      className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                      title={showTextoParteServico ? "Editar Texto" : "Fechar Edição"}
                      onClick={() => {
                        setShowTextoParteServico(!showTextoParteServico);
                      }}
                    />
                    <VscReplace
                      className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                      title="Visualizar texto com substituições"
                      onClick={() =>
                        setShowModalParteServico({
                          show: true,
                          body: <HtmlToString html={formik.values.txTextoPadrao} />,
                          // context: anexo.sequencial,
                        })
                      }
                    />
                  </Form.Label>
                  <Row className="ml-1">
                    {showTextoParteServico && formik.values.txTextoPadrao !== false && (
                      <HtmlEditor className="form-control-alt" formik={formik} field="txTextoPadrao" rows="5" />
                    )}
                  </Row>
                </Form.Group>
              </Row>

              <Row className="ml-1 mb-2">Anexos:</Row>
              <Row className="mb-5">
                <Form.Group as={Col} xs={12}>
                  <SelectFileInput formik={formik} field="anexos" save multiple />
                </Form.Group>
              </Row>

              <Row>
                {(formik.values.txStParteServico === "S" || formik.values.txStParteServico === undefined) && (
                  <Form.Group as={Col} xs={12} md={3}>
                    <Form.Label>
                      <CheckBoxFormik
                        inline="inline"
                        formik={formik}
                        field="isAssinar"
                        label="Assinar com Certificado Digital"
                      />
                    </Form.Label>
                  </Form.Group>
                )}
              </Row>

              <Row>
                <Col>
                  {formik.isSubmitting ? (
                    <TextSpinner text="Registrando Parte de Serviço..." />
                  ) : (
                    <Button
                      disabled={
                        formik.values.txStParteServico !== undefined &&
                        formik.values.txStParteServico !== "A" &&
                        formik.values.txStParteServico !== "G" &&
                        formik.values.txStParteServico !== "S"
                      }
                      variant="primary"
                      className="mr-3"
                      size="md"
                      onClick={formik.handleSubmit}
                    >
                      Salvar Parte de Serviço
                    </Button>
                  )}
                  <Button variant="light" className="mr-3" onClick={() => resetForm()}>
                    Limpar
                  </Button>
                  {!formik.isSubmitting && (
                    <Button variant="danger" onClick={() => history.goBack()}>
                      Cancelar
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParteServicoOs;
